"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TOKENS = exports.LABEL_TYPE = void 0;
const LABEL_TYPE = exports.LABEL_TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};
const TOKENS = exports.TOKENS = {
  LABEL_COLOR: 'labelColor',
  TEXT_COLOR: 'textColor'
};